export enum AudioChannelEnum {
  Mono = 1,
  Stereo = 2,
  DolbySurroundSound = 6, // 5.1
}

export type AudioChannel =
  | AudioChannelEnum.Mono
  | AudioChannelEnum.Stereo
  | AudioChannelEnum.DolbySurroundSound;
